module.exports = __webpack_public_path__ + "static/media/config-icon.feae1582.png";